export default "__VITE_ASSET__BIxW6bNf__"